/* eslint no-console: "off", no-use-before-define: ["error", { "variables": false }] */
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import webSocket from '@/common/webSocket';
import ResumeGame from '@/components/home/modals/ResumeGame';
import ZeroBalance from '@/components/home/modals/ZeroBalance';
import ResubscribeGameSms from '@/components/home/modals/ResubscribeGameSms';
import ResubscribeGame from '@/components/home/modals/ResubscribeGame';
import Maintenance from '@/components/home/modals/shared/Maintenance';
import NoBalanceModal from '../../../components/home/modals/NoBalanceModal';
import DeclinedRequest from '../../../components/home/game/challenge/DeclinedRequest';
import PendingChallengedRequest from '../../../components/home/game/challenge/PendingChallengedRequest';
import ConfirmChallengeRequestRematch from '../../../components/home/game/challenge/ConfirmChallengeRequestRematch';
import ConfirmChallengeRequest from '../../../components/home/game/challenge/ConfirmChallengeRequest';
import PendingChallengedRequestRematch from '../../../components/home/game/challenge/PendingChallengedRequestRematch';

export const RematchMixin = {
  data() {
    return {
      stompClientForNotifications: null,
      connectionTimerNotifications: null,
      notificationSubscription: null,
      serverUnderMaintenance: false,
    };
  },
  methods: {
    ...mapMutations('users', [
      'setOnlineUsers',
    ]),
    ...mapMutations('game', [
      'setTransitionOnlyForSearchingToOpponent',
      'resetGameState',
      'setGameInProgress',
      'setGameID',
      'setPlayersDetails',
      'updateChallengeInfo',
      'setToDefaultChallengeInfo',
    ]),
    ...mapMutations('users', [
      'setDeclinedReason',
    ]),
    ...mapMutations('common', [
      'storeModalForChallenge',
      'storeModalForHomePage',
    ]),
    ...mapMutations('profile', [
      'storeNotificationsFromSocket',
    ]),
    saveResponseData(responseData) {
      this.setGameID(responseData.gameId);
      this.setPlayersDetails({
        homePlayerMSISDN: responseData.homeUserDetails.msisdn,
        homePlayerUsername: responseData.homeUserDetails.username,
        homePlayerAvatar: responseData.homeUserDetails.avatar,
        homePlayerLevel: responseData.homeUserDetails.currentLevel,
        awayPlayerMSISDN: responseData.awayUserDetails.msisdn,
        awayPlayerUsername: responseData.awayUserDetails.username,
        awayPlayerAvatar: responseData.awayUserDetails.avatar,
        awayPlayerLevel: responseData.awayUserDetails.currentLevel,
      });
    },
    resetModals() {
      this.storeModalForChallenge(null);
      this.setToDefaultChallengeInfo();
    },
    rematchWithSpecificUser() {
      this.stompClientForNotifications = webSocket.getNotificationsStompClient();
      if (this.stompClientForNotifications === null) {
        this.stompClientForNotifications = webSocket.createNewStompClient('/notificationsData');
      }
      // DO NOT FORGET TO HAVE A BEFOREDESTROY HOOK TO UNSUBSCRIPTED FROM ACTIVE SUB
      const stompSuccess = (frame) => {
        // eslint-disable-next-line
        console.log(`In rematchWithSpecificUser component: ${frame}`);
        clearTimeout(this.connectionTimerNotifications);
        this.notificationSubscription = this.stompClientForNotifications.subscribe(`/topic/notificationsData/${this.userDetails.msisdn}`, (response) => {
          // parse server response and return if any errors occur
          const responseData = this.parseServerResponse(response.body);
          if (responseData === null) {
            return;
          }
          // eslint-disable-next-line
          console.log('responseData:', responseData);
          if ('notificationCategoryDTO' in responseData) {
            this.storeNotificationsFromSocket({ notifications: responseData });
          }
          if (responseData.challengeDTOEnum === 'CHALLENGE_FROM_USER_JUST_ARRIVED') {
            // if a challenge from a user occurs, then give it high priority and close the others challenge modals
            if (this.modalForChallenge) this.resetModals();
            this.$nextTick(() => {
              this.updateChallengeInfo({
                challengedLevel: responseData.challengedUser.userLevel,
                challengingLevel: responseData.challengingUser.userLevel,
                challengedMsisdn: responseData.challengedUser.msisdn,
                challengingMsisdn: responseData.challengingUser.msisdn,
                challengedUsername: responseData.challengedUser.username,
                challengingUsername: responseData.challengingUser.username,
                challengedAvatar: responseData.challengedUser.avatar,
                challengingAvatar: responseData.challengingUser.avatar,
                challengingStickerIcon: responseData.challengingUser.stickerIcon,
                opponentIsBot: false,
              });
              this.storeModalForChallenge(PendingChallengedRequest);
            });
          } else if (responseData.challengeDTOEnum === 'CHALLENGE_REMATCH_FROM_USER_JUST_ARRIVED') {
            // if a challenge from a user occurs, then give it high priority and close the others challenge modals
            if (this.modalForChallenge) this.resetModals();
            this.$nextTick(() => {
              this.updateChallengeInfo({
                challengedLevel: responseData.challengedUser.userLevel,
                challengingLevel: responseData.challengingUser.userLevel,
                challengedMsisdn: responseData.challengedUser.msisdn,
                challengingMsisdn: responseData.challengingUser.msisdn,
                challengedUsername: responseData.challengedUser.username,
                challengingUsername: responseData.challengingUser.username,
                challengedAvatar: responseData.challengedUser.avatar,
                challengingAvatar: responseData.challengingUser.avatar,
                forRematchHomeScore: responseData.finishedGameDetailsDTO.homeScore,
                forRematchAwayScore: responseData.finishedGameDetailsDTO.awayScore,
                forRematchIsHome: responseData.finishedGameDetailsDTO.home,
              });
              this.storeModalForChallenge(PendingChallengedRequestRematch);
            });
          } else if (responseData.challengeDTOEnum === 'CHALLENGE_FROM_OPPONENT_DECLINED') {
            this.setDeclinedReason(this.getTranslations.home_rematch_generic_msg_challenge_declined_req);
            this.storeModalForChallenge(DeclinedRequest);
          } else if (responseData.challengeDTOEnum === 'YOU_DID_NOT_CHALLENGE') {
            this.resetModals();
            this.$nextTick(() => {
              this.setDeclinedReason(this.getTranslations.home_rematch_generic_msg_challenge_timeout);
              this.storeModalForChallenge(DeclinedRequest);
            });
          } else if (responseData.challengeDTOEnum === 'CHALLENGE_WITH_A_BOT') {
            if (!this.modalForChallenge) { // never send an challenge to user from automatic bot if another challenge modal is displaying at that moment
              this.updateChallengeInfo({
                challengedLevel: responseData.challengedUser.userLevel,
                challengingLevel: responseData.challengingUser.userLevel,
                challengedMsisdn: responseData.challengedUser.msisdn,
                challengingMsisdn: responseData.challengingUser.msisdn,
                challengedUsername: responseData.challengedUser.username,
                challengingUsername: responseData.challengingUser.username,
                challengedAvatar: responseData.challengedUser.avatar,
                challengingAvatar: responseData.challengingUser.avatar,
                challengingStickerIcon: 1,
                opponentIsBot: true,
              });
              this.storeModalForChallenge(PendingChallengedRequest);
            }
          } else if (responseData.challengeDTOEnum === 'OPPONENT_DID_NOT_ANSWERED') {
            this.setDeclinedReason(this.getTranslations.home_rematch_generic_msg_challenge_timeout_by_opp);
            this.storeModalForChallenge(DeclinedRequest);
          } else if (responseData.gameStateEnum === 'OPPONENT_FOUND') {
            this.storeModalForChallenge(null); // close all pending modals
            this.storeModalForHomePage(null);
            this.resetGameState();
            this.setGameInProgress(true);
            this.setTransitionOnlyForSearchingToOpponent(true);
            this.saveResponseData(responseData);
            clearInterval(this.connectionTimer);
            this.normalTransition = true;
            this.$router.replace('/opponentFound');
            console.log('going to opponent found page...');
          }
          // eslint-disable-next-line
        }, (errorResponse) => { // error callback
          console.log(errorResponse);
        });
      };

      const stompFailure = (error) => {
        // eslint-disable-next-line
        console.log(error);
        clearTimeout(this.connectionTimerNotifications);
        this.connectionTimerNotifications = setTimeout(() => {
          this.stompClientForNotifications = webSocket.createNewStompClient('/notificationsData');
          connect();
        }, 3000);
      };
      const connect = (() => {
        if (!this.stompClientForNotifications.connected) {
          this.stompClientForNotifications.connect({ Authorization: this.jwtInVuex }, stompSuccess, stompFailure);
        } else {
          stompSuccess();
        }
      });
      connect();
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('common', [
      'userDetails',
      'modalForHomePage',
      'modalForChallenge',
    ]),
  },
};

export const ChecksToStartNewGame = {
  methods: {
    ...mapMutations('common', [
      'storeModalForChallenge',
    ]),
    ...mapActions('game', [
      'checkIfGameToResumeExists',
    ]),
    ...mapActions('profile', [
      'checkCoreResponses',
    ]),
    ...mapMutations('game', [
      'updateChallengeInfo',
    ]),
    checkGameValidations(isRematched, opponentName, opponentAvatar, opponentLevel) {
      console.log(isRematched);
      this.checkCoreResponses().then((response) => {
        if (response === 'CORE_IS_DOWN') {
          this.storeModalForChallenge(Maintenance);
        } else {
          this.checkIfGameToResumeExists().then(() => {
            const activeIntegrationConfig = this.getActiveIntegrationConfig;
            if (this.gameInProgress) {
              this.storeModalForChallenge(ResumeGame);
            } else if (this.userDetails.availableGames === 0 && !this.userDetails.subscribed) {
              if (this.subAndUnsubViaSMS) {
                if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
                  this.storeModalForChallenge(ResubscribeGameSms);
                } else {
                  this.storeModalForChallenge(ResubscribeGame);
                }
              } else {
                this.storeModalForChallenge(ResubscribeGame);
              }
            } else if (this.userDetails.availableGames === 0 && this.userDetails.subscribed) {
              this.storeModalForChallenge(ZeroBalance);
            } else if (activeIntegrationConfig && activeIntegrationConfig.hasNoBalance && this.userDetails.parked) {
              this.storeModalForChallenge(NoBalanceModal);
            } else {
              console.log('Proceed to challenge the opponent');
              this.updateChallengeInfo({
                challengedLevel: opponentLevel === null || opponentLevel === 0 || opponentLevel === 0.0 ? this.userDetails.level : opponentLevel,
                challengingLevel: this.userDetails.level,
                challengedMsisdn: null,
                challengingMsisdn: this.userDetails.msisdn,
                challengedUsername: opponentName,
                challengingUsername: this.userDetails.username,
                challengedAvatar: opponentAvatar,
                challengingAvatar: this.userDetails.avatar,
              });
              this.storeModalForChallenge(isRematched ? ConfirmChallengeRequestRematch : ConfirmChallengeRequest);
            }
          }).catch(error => console.error(error));
        }
      }).catch(error => console.error(error));
    },
  },
  computed: {
    ...mapState('game', [
      'gameInProgress',
    ]),
    ...mapState('common', [
      'userDetails',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
    ]),
    ...mapGetters('common', [
      'getActiveIntegrationConfig',
    ]),
  },
};

export const BeforeDestroyRematch = {
  beforeDestroy() {
     /* eslint-disable */
    console.log(`in ${this.$options.name} beforeDestroy hook HERE`);
    console.log('this.notificationSubscription', this.notificationSubscription);
    // if for any reason we leave this component earlier from the websocket's response,
    // unsubscribe from the subscribed channel
    if (this.onlineSubscription)
      this.onlineSubscription.unsubscribe();
    if (this.stompClientForOnlineUsers)
      // this.stompClientForOnlineUsers.disconnect();
    if (this.notificationSubscription)
      this.notificationSubscription.unsubscribe();
    if (this.stompClientForNotifications)
    // this.stompClientForNotifications.disconnect();
      if (this.connectionTimerNotifications) {
        clearInterval(this.connectionTimerNotifications);
      }
    if (this.connectionTimerOnlineUsers) {
      clearInterval(this.connectionTimerOnlineUsers);
    }
  },
};





// WEBPACK FOOTER //
// ./src/common/mixins/rematch/rematch.js